import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {
  mediaTabletAndUp,
  mobileOnly,
  tabletAndUp,
} from '../../../constants/customMedia';
import {OptionContentProps} from '../SizeOption/OptionContent';
import {SizeOptionWithRadioButton} from '../SizeOption/SizeOptionWithRadioButton';
import {SizeOptionProps} from '../SizeOption/types';

interface SizesProps {
  onSizeSelect: (sizeId: number) => void;
  selectedSizeId: number | undefined;
  sizes: Array<SizeOptionProps>;
  displayVariantPrices?: boolean;
  className?: string;
  setContentFullHeight?: boolean;
}

export const Sizes: FC<SizesProps & OptionContentProps> = ({
  onSizeSelect,
  selectedSizeId,
  sizes,
  displayVariantPrices,
  className,
  enableEndBadgeBellIcon,
  setContentFullHeight,
}) => {
  return (
    <Wrapper
      data-testid="sizeList"
      className={className}
      $setContentFullHeight={setContentFullHeight}
      tabIndex={0}
    >
      {sizes.map(size => (
        <Size
          key={`sizeListSizeOption_${size.id}`}
          data-is-selected={size.id === selectedSizeId}
        >
          <SizeOptionWithRadioButton
            {...size}
            selected={selectedSizeId === size.id}
            onSizeSelect={onSizeSelect}
            displayVariantPrices={displayVariantPrices}
            enableEndBadgeBellIcon={enableEndBadgeBellIcon}
          />
        </Size>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.ul<{
  $setContentFullHeight?: boolean;
}>`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${COLORS.Grey3};
  list-style: none;
  padding: 0.5rem 0;
  margin: 0;
  overflow-y: scroll;

  @media ${mediaTabletAndUp} {
    max-height: 240px;
  }

  ${({$setContentFullHeight}) =>
    $setContentFullHeight &&
    css`
      max-height: 100%;

      @media ${mediaTabletAndUp} {
        max-height: 100%;
      }
    `}
`;

const Size = styled.li`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;

  transition: background-color 0.2s ease-in-out;
  ${tabletAndUp(css`
    &:hover {
      cursor: pointer;
      background-color: ${COLORS.Grey4};
    }
  `)}

  ${mobileOnly(css`
    &[data-is-selected='true'] {
      background-color: ${COLORS.Grey5};
    }
  `)}
`;
